// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingAnimation_fasting_container__2_Pfx","logo":"LoadingAnimation_fasting_logo__376_T","text":"LoadingAnimation_fasting_text__1UlIt"};